/* eslint react/jsx-no-target-blank: 0 */

import React, { Component, Fragment } from "react"
import { BrowserRouter as Router, Route } from "react-router-dom"
import Helmet from "react-helmet"
import Bar from "./components/Bar/index"
import Footer from "./components/Footer"
import { DataContext } from "./index"

import tea from "./tea.png"

import Banner from "./containers/Banner"
import SearchForm from "./containers/SearchForm/index"

const Form = () => (
  <DataContext.Consumer>
    {value => <SearchForm data={value} />}
  </DataContext.Consumer>
)

// eslint-disable-next-line
class App extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Delivery Now Milktea App</title>
          <meta
            name="description"
            content="React app to solve what is missing from delivery now"
          />
          <meta name="og:title" content="Delivery Now Milktea App" />
          <meta
            name="og:description"
            content="React app to solve what is missing from delivery now"
          />
          <meta name="twitter:title" content="Delivery Now Milktea App" />
          <meta
            name="twitter:description"
            content="React app to solve what is missing from delivery now"
          />
          <meta name="twitter:image" content={tea} />
          <meta name="og:image" content={tea} />
        </Helmet>
        <Banner />
        <Bar />
        <Router>
          <Route path="/:city?/:store?/:maxprice?" component={Form} />
        </Router>
        <Footer>
          {" "}
          Made by{" "}
          <a target="_blank" href="http://namnguyen.design">
            Nam Nguyen
          </a>
        </Footer>
      </Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js